import React, {useState, useEffect} from "react";
import {InfoHeaderBlock} from "../services/GeneralServices";
import parse from "html-react-parser";

export const HeadersContext = React.createContext();

export default function HeadersProvider({children}) {
   // const [HeadersList, setHeaders] = useState([]);
   const [essentialHeader, setEssentialHeader] = useState({loading: true});
   const [primeHeader, setPrimeHeader] = useState({loading: true});
   const [emblemHeader, setEmblemHeader] = useState({loading: true});
   const [enterpriseHeader, setEnterpriseHeader] = useState({loading: true});
   const [facilitatorHeader, setFacilitatorHeader] = useState({loading: true});
   const [academyHeader, setAcademyHeader] = useState({loading: true});

   const getHeader = (type) => {
      if (comprobateExist) {
         InfoHeaderBlock(type)
            .then((res) => res.json())
            .then((resp) => {
               const {status, data} = resp;
               if (status === "error") throw new Error();
               let formatData = {...data[0], description: data[0].description};
               setDataHeader(formatData);
            })
            .catch((e) => {
               console.log(e);
            });
      }
   };

   function setDataHeader(data) {
      switch (data.type) {
         case "Essentials":
            setEssentialHeader({...data, loading: false});
            break;
         case "Prime":
            setPrimeHeader({...data, loading: false});
            break;
         case "Emblem":
            setEmblemHeader({...data, loading: false});
            break;
         case "Enterprise":
            setEnterpriseHeader({...data, loading: false});
            break;
         case "Facilitator":
            setFacilitatorHeader({...data, loading: false});
            break;
         case "Academy":
            setAcademyHeader({...data, loading: false});
            break;
         default:
            return null;
      }
   }
   function comprobateExist(type) {
      switch (type) {
         case "Essentials":
            return !!essentialHeader;
         case "Prime":
            return !!primeHeader;
         case "Emblem":
            return !!emblemHeader;
         case "Enterprise":
            return !!enterpriseHeader;
         case "Facilitator":
            return !!facilitatorHeader;
         case "Academy":
            return !!academyHeader;
         default:
            return false;
      }
   }

   return (
      <HeadersContext.Provider
         value={{
            getHeader, // obtener cualquier header
            essentialHeader, // essencial
            primeHeader, // prime
            emblemHeader, // Emblem
            enterpriseHeader, // enterprise
            facilitatorHeader, // facilitadores
            academyHeader, // domecq academy
         }}
      >
         {children}
      </HeadersContext.Provider>
   );
}
